// src/hooks/useToast.ts
import { useAlert } from '../contexts/AlertContext';
import { AlertType } from '../types/Alert';

export const useToast = () => {
  const { addAlert } = useAlert();

  const toast = {
    success: (title: string, message?: string, duration?: number) => {
      addAlert('success', title, message, duration);
    },
    error: (title: string, message?: string, duration?: number) => {
      addAlert('error', title, message, duration);
    },
    warning: (title: string, message?: string, duration?: number) => {
      addAlert('warning', title, message, duration);
    },
    info: (title: string, message?: string, duration?: number) => {
      addAlert('info', title, message, duration);
    },
  };

  return toast;
};